import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {reopenBox} from "../../../services/api/apiNextBox"


class ReopenBox extends Component {
    state = {
        loading: false,
    }

    _handleClickReopen = async e => {
        e.preventDefault()

        if (this.state.loading) return false

        this.setState({
            loading: true
        })

        const {_id: boxId} = this.props.box

        try {
            const {success, message} = await reopenBox(boxId)

            if (!success) {
                throw new Error(message)
            }

            this.setState({
                loading: false
            }, () => {
                this.props.onRefresh()
            })
        } catch (err) {
            window.alert(err.message || err)

            this.setState({
                loading: false,
            })
        }
    }

    render() {
        const {box, isPrivate} = this.props

        if (!isPrivate) return null

        const {status} = box
        if (status !== 'closed') return null

        const {loading} = this.state

        return (
            <div className="ReopenBox card-footer">
                <div className="d-flex justify-content-center">
                    <button onClick={this._handleClickReopen}
                            disabled={loading}
                            className="btn btn-success">Reopen
                    </button>
                </div>
            </div>
        )
    }
}

ReopenBox.propTypes = {
    isPrivate: PropTypes.bool.isRequired,
    box: PropTypes.object.isRequired,
    onRefresh: PropTypes.func.isRequired,
}

export default ReopenBox
